import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { scroller } from 'react-scroll';
import Helpers from '~/utils/Helpers';
import classNames from 'classnames';
import * as artifactActions from '~/artifact/actions';
import { vulnerabilityRangeTypesMap, vulnSectionsMap } from '~/constants/ModelConstants';
import ArtifactHelper from '~/utils/ArtifactHelper';
import StringService from '~/utils/StringService';
import LoaderWrapper from '~/components/LoaderWrapper';
type ArtifactLibraryListProps = {
  artifactState: object;
  actions: object;
  disableClick?: boolean;
  vcPageState: object;
};
class ArtifactLibraryList extends React.Component<ArtifactLibraryListProps, {}> {
  componentDidMount() {
    const { artifactState } = this.props;
    const { componentId } = artifactState;
    const { affectedComponents = [] } = artifactState;
    const activeComponent =
      affectedComponents.find(component => component.id === componentId) ||
      affectedComponents[0] ||
      {};
    if (activeComponent && activeComponent.id && !componentId) {
      this.props.actions.updateComponentVersion(activeComponent.versions[0].version);
      this.props.actions.updateComponentId(activeComponent.id);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { artifactState: prevArtifactState } = this.props;
    const {
      componentId: prevComponentId,
      affectedComponents: prevAffectedComponents,
    } = prevArtifactState;
    const prevComponent =
      prevAffectedComponents.find(component => component.id === prevComponentId) ||
      prevAffectedComponents[0] ||
      {};
    const { artifactState: nextArtifactState } = nextProps;
    const {
      componentId: nextComponentId,
      affectedComponents: nextAffectedComponents,
    } = nextArtifactState;
    const nextComponent =
      nextAffectedComponents.find(component => component.id === nextComponentId) ||
      nextAffectedComponents[0] ||
      {};
    if (prevComponent.id !== nextComponent.id) {
      this.props.actions.updateComponentVersion(nextComponent.versions[0].version);
      this.props.actions.fetchVulnerableComponentVersions(nextComponent.id);
      this.props.actions.updateComponentId(nextComponent.id);
    }
  }
  handleUpdateActiveComponent = id => {
    const { artifactState } = this.props;
    const { artifact = {}, affectedComponents = [] } = artifactState;
    const { artifactComponents = [] } = artifact;
    const artifactComponent = artifactComponents.find(component => component.componentId === id);
    const { versionRanges = [] } = artifactComponent;
    const nonHeadVersionRanges = versionRanges.filter(range => range.versionRange !== 'HEAD');
    const component = affectedComponents.find(component => component.id === id);
    const { versions } = component;
    const version = versions[0] || {};
    this.props.actions.updateComponentId(id);
    this.props.actions.updateComponentVersion(version.version);
    this.props.actions.fetchVulnerableComponentVersions(id);
    this.props.actions.updateIsDisplayVulnerableVersions(false);
    //Resets to default state of version/commit hash tab
    this.props.actions.updateActiveVulnRangeTab(vulnerabilityRangeTypesMap.VERSIONS);
    this.props.actions.updateArtifactActiveCommitHash('');
    this.props.actions.updateActiveSafeCommitHash('');
    this.props.actions.updateVulnerableRangeByComponent(nonHeadVersionRanges[0]);
    // Scrolls to the section element
    scroller.scrollTo(vulnSectionsMap.LIBRARY_INFORMATION, {
      smooth: true,
      offset: -50,
    });
  };
  render() {
    const {
      artifactState,
      disableClick = false,
      vcPageState: { shouldShowVeracodePage },
    } = this.props;
    const { artifact = {}, isFetching = false, componentId: activeComponentId } = artifactState;
    const { artifactComponents: components = [] } = artifact;
    const baseGothamFontClasses = classNames({
      'font-family--gotham': shouldShowVeracodePage,
    });
    const librariesListHtml = components.map((component, index) => {
      const {
        componentId: id,
        componentName: name = '',
        coordOne: coordinate1 = '',
        coordTwo: coordinate2 = '',
        componentCoordinateType: coordinateType = '',
      } = component;
      const languageType = ArtifactHelper.getLanguageByCoordType(coordinateType);
      const componentLink = StringService.createSEOComponentItemUrl(
        name,
        languageType,
        id,
        coordinateType
      );
      const isActive = id === activeComponentId;
      const libraryTypeText =
        Helpers.sanitizePackageManagerType(coordinateType) ||
        Helpers.sanitizeLanguageType(languageType);
      const baseTitilliumFontClasses = classNames({
        'font-family--titillium': shouldShowVeracodePage,
      });
      return (
        <li
          key={`${id}-${index}`}
          className={`no-style ph pt- position--relative bg-color--transition-300ms-ease-out ${
            !disableClick ? 'cursor-on-hover--pointer bg-color--hover-primary' : ''
          } ${isActive && !disableClick ? 'bg-color--white-dark bg-color--hover-muted-light' : ''}`}
          onClick={() => !disableClick && this.handleUpdateActiveComponent(id)}
        >
          <Link to={componentLink} className="link--obvious">
            <strong className={`${baseTitilliumFontClasses}-light`}>{name}</strong>
          </Link>
          <span className="block">
            <span className={`${baseTitilliumFontClasses}-regular font--10 block`}>
              {libraryTypeText.toUpperCase()}
            </span>
            <span className={`${baseTitilliumFontClasses}-regular font--10`}>COORDS: </span>
            {coordinate1 && (
              <span
                className={`${baseTitilliumFontClasses}-regular font--12 color--black-light pb-`}
              >
                {coordinate1}
                {coordinate2 ? `, ${coordinate2}` : ''}
              </span>
            )}
            <span className="block width--40 bo-b--1 pt- border-color--muted-light" />
          </span>
        </li>
      );
    });
    return (
      <div className="grid__item col-1-1">
        <div className="bo--1 bg-color--white-light border-color--white-dark bo-rad--top-3">
          <div className="bo-b--2 border-color--white-dark">
            <div
              className={`${baseGothamFontClasses}-medium text--bold hover--no-underline inline-block height--40 ph pt-`}
            >
              Libraries{' '}
              <span className="font--12 text--bold inline-block bg-color--muted-dark color--white pv--- ph-- bo-rad--5 ml-- mt---">
                {components.length}
              </span>
            </div>
          </div>
        </div>
        <div className="bo--1 border-color--muted-light bo-rad--bottom-3 max-height--615 overflow-y--scroll">
          <LoaderWrapper
            isLoaderShowing={isFetching}
            loaderType="SPINNER"
            loaderClassName="p text--center"
          >
            <ul className="list-style--none p0 m0">
              {components.length > 0 ? (
                librariesListHtml
              ) : (
                <li className="p">No libraries found</li>
              )}
            </ul>
          </LoaderWrapper>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    vcPageState: state.vcPageState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactLibraryList);
